import widgets from "styles/widgets";
import listItemStyles from "styles/list-item-styles";
import { useMouseTilt } from "hooks/mouse-tilt.hook";
import { CardSetTypeDto } from "dtos/shard/card-set-type.dto";

export default function CardSetTypeItem(props: {
    id: string,
    cardSetType?: CardSetTypeDto,
    selected: boolean,
    onClick?: (cardSetType?: CardSetTypeDto) => void,
}): JSX.Element
{
    // Actions:
    const onClick = () => {
        if (props.onClick) {
            props.onClick(props.cardSetType);
        }
    }
    const [mouseMove, mouseLeave] = useMouseTilt();

    // Styles:
    const widgetClasses = widgets();
    const listItemClasses = listItemStyles({
        create: !!props.cardSetType,
        selected: props.selected,
    });
    
    // Return Component:
    return (
        <div
            onClick={() => onClick()}
            onMouseMove={mouseMove}
            onMouseLeave={mouseLeave}
            className={`${listItemClasses.container}`}
        >
            <div className={`${listItemClasses.tile} ${widgetClasses.mouseTilt}`}>
                {props.cardSetType ? (<>
                    <div className={`${listItemClasses.title}`}>
                        <span>{props.cardSetType.name.replace(props.cardSetType.name[0], props.cardSetType.name[0].toUpperCase())}</span>
                    </div>
                </>) : (<>
                    <div className={`${listItemClasses.title}`}>
                        <span>{props.id === "create" ? "Create New" : "No"} Card Set Type</span>
                    </div>
                </>)}
            </div>
        </div>
    );
}